import React from 'react';
import './ContactPage.css';
import { MapPin, Phone, Mail, Clock, Users, Calendar, Building } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="container">
        <h1 className="page-title">اتصل بنا</h1>
        <p className="page-subtitle">
          نحن هنا لمساعدتك في جميع استفساراتك حول منتجاتنا وخدماتنا
        </p>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="office-section">
              <h2 className="office-title">مكتب الشرق الأوسط</h2>
              <div className="office-details">
                <div className="contact-item">
                  <Building size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>الشركة:</strong>
                    <p>Nasatronic</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Users size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>الاسم:</strong>
                    <p>Roger Abou Rashed</p>
                  </div>
                </div>
                <div className="contact-item">
                  <MapPin size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>العنوان:</strong>
                    <p>Wady shahroor, Street 7, Road 29, Beirut 1100, Lebanon</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Phone size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>الهاتف:</strong>
                    <p className="phone-number">+961 79 334 256</p>
                    <p className="phone-number">+961 3 892 893</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Mail size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>البريد الإلكتروني:</strong>
                    <p>info@aquabroadcast.me</p>
                    <p>roger@aquabroadcast.me</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="office-section">
              <h2 className="office-title">المقر الرئيسي</h2>
              <div className="office-details">
                <div className="contact-item">
                  <MapPin size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>العنوان:</strong>
                    <p>Aqua Broadcast Limited</p>
                    <p>Unit 7, First Quarter</p>
                    <p>Blenheim Road</p>
                    <p>Epsom, KT19 9QN</p>
                    <p>United Kingdom</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Phone size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>الهاتف الدولي:</strong>
                    <p className="phone-number">+44 203 411 0387</p>
                  </div>
                </div>
                <div className="contact-item">
                  <Mail size={24} className="contact-icon" />
                  <div className="contact-text">
                    <strong>البريد الإلكتروني:</strong>
                    <p>info@aquabroadcast.co.uk</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="map-container">
            <h3 className="map-title">موقعنا في لبنان</h3>
            <div className="map-wrapper">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d848038.0751809055!2d35.18803876697908!3d33.87294256793861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f17028422aaad%3A0xcc7d34096c00f970!2sLebanon!5e0!3m2!1sen!2slb!4v1757771222695!5m2!1sen!2slb" 
                allowFullScreen
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade"
                title="Lebanon Location Map"
              />
            </div>
          </div>
        </div>

        <div className="additional-sections">
          <div className="additional-services">
            <h3 className="services-title">خدمات إضافية</h3>
            <div className="service-links">
              <a href="#newsletter" className="service-link">
                <Mail size={20} />
                اشترك في النشرة الإخبارية
              </a>
              <a href="#dealer" className="service-link">
                <Users size={20} />
                هل تريد أن تصبح موزعاً؟
              </a>
              <a href="#meeting-en" className="service-link">
                <Calendar size={20} />
                حدد موعد اجتماع (إنجليزي)
              </a>
              <a href="#meeting-es" className="service-link">
                <Calendar size={20} />
                حدد موعد اجتماع (إسباني)
              </a>
            </div>
          </div>

          <div className="business-hours">
            <h3 className="hours-title">ساعات العمل</h3>
            <div className="hours-item">
              <Clock size={20} className="hours-icon" />
              <div className="hours-text">
                <p>الدعم والمبيعات متاحان على مدار الساعة</p>
                <p>سواء كان ذلك عبر مكالمة هاتفية أو بريد إلكتروني، نحن معك في كل خطوة</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form - Commented out for now */}
        {/*
        <div className="contact-form-section">
          <h3 className="form-title">أرسل لنا رسالة</h3>
          <form className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">الاسم الكامل</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">البريد الإلكتروني</label>
                <input type="email" id="email" name="email" required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">رقم الهاتف</label>
                <input type="tel" id="phone" name="phone" />
              </div>
              <div className="form-group">
                <label htmlFor="company">اسم الشركة</label>
                <input type="text" id="company" name="company" />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="subject">الموضوع</label>
              <input type="text" id="subject" name="subject" required />
            </div>
            <div className="form-group">
              <label htmlFor="message">الرسالة</label>
              <textarea id="message" name="message" rows="6" required></textarea>
            </div>
            <button type="submit" className="submit-btn">
              إرسال الرسالة
            </button>
          </form>
        </div>
        */}
      </div>
    </div>
  );
};

export default ContactPage;
